import useAuth from '../../auth/authContext';
import { PleaseRelogin } from '../../auth/PleaseRelogin';
import React from 'react';
import { MultilevelTabPanel } from '../../commons/components/MultilevelTabPanel';
import ProgramCalendar from '../../program/containers/ProgramCalendar';
import Programs from '../../program/containers/Programs';
import AnalyticsTabs from '../../analytics/containers/AnalyticsTabs';

const PlanningTabs = () => {
  const {
    state: { user },
  } = useAuth();

  if (!user) return <PleaseRelogin />;

  return (
    <MultilevelTabPanel
      persistablePrefix="PlanningTabs"
      tabs={[
        {
          title: 'Calendar',
          dataTest: 'planning__calendar-tab',
          subTabs: [
            {
              id: 'planning__programs-calendar',
              hasAccess: true,
              dataTest: 'planning__programs-calendar',
              title: null,
              body: <ProgramCalendar />,
            },
          ],
        },
        {
          title: 'Table',
          dataTest: 'planning__table-tab',
          subTabs: [
            {
              id: 'planning__programs-table',
              hasAccess: true,
              dataTest: 'planning__programs-table',
              title: null,
              body: <Programs />,
            },
          ],
        },
        {
          title: 'Analytics',
          dataTest: 'planning__analytics-tab',
          subTabs: [
            {
              id: 'planning__programs-analytics',
              hasAccess: true,
              dataTest: 'planning__programs-analytics',
              title: null,
              body: <AnalyticsTabs />,
            },
          ],
        },
      ]}
    />
  );
};

export default PlanningTabs;
